import React from 'react';
import { Renderer, componentType } from './Renderer';

class App extends React.Component {
  workflowRef;
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          "name": "text",
          "title": "Heading",
          "placeHolder": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          "description": "test",
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#b0bbcf"
          },
          "type": "text"
        },
        {
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#e1e6f0"
          },
          "type": "list",
          "ListingData": [
            { "value": "Phasellus vestibulum nulla a mi mattis, in fringilla elit sodales.", "isDelete": false },
            { "value": "Duis ullamcorper massa tincidunt, euismod tortor et, mollis erat.", "isDelete": false },
            { "value": "Pellentesque lobortis ut dolor laoreet sollicitudin et vitae justo.", "isDelete": false },
            { "value": "Mauris maximus lorem vitae neque pellentesque, sit amet aliquam turpis feugiat.", "isDelete": false }
          ]
        },
        {
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#b0bbcf"
          },
          "placeHolder": "",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          "url": "https://miro.medium.com/max/1200/1*mk1-6aYaf_Bes1E3Imhc0A.jpeg",
          "type": "image"
        },
        {
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#e1e6f0"
          },
          "placeHolder": "Enter text caption here",
          "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          "url": "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
          "type": "video"
        },
        {
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#b0bbcf"
          },
          "type": "icon",
          ListingData: [
            { value: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', isDelete: false, name: 'video.mp4' },
            { value: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', isDelete: false, name: 'video.mp4' },
            { value: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', isDelete: false, name: 'video.mp4' },
          ],
        },
        {
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#e1e6f0"
          },
          "type": "divider"
        },
        {
          "title": "Continue",
          style: {
            "padding_top": 10,
            "padding_bottom": 10,
            "bgColor": "#b0bbcf"
          },
          "type": "button"
        }
      ],
    };
    this.workflowRef = React.createRef();
  }

  onClickNext = (index, tabData) => {
    setTimeout(() => {
      this.workflowRef.current.showNextTab();
    }, 3000);
  };

  onFormSubmitted = (step, response) => {
    console.log(step, response);
  };

  onChangeComponent = (e, type, tabIndex, componentIndex) => {
    console.log(e, type, tabIndex, componentIndex);
  }

  onChangeTab = (activeTab, data) => {
    if (activeTab === this.state.data.length - 1) {
      // this.props.sendData(data);
    } else {
      // this.workflowRef.current.showNextTab();
    }
  };

  render() {
    const { data } = this.state;
    return (
      <div>
        <Renderer formData={data} onFormSubmitted={this.onFormSubmitted} ref={this.workflowRef} onChangeComponent={this.onChangeComponent} onChangeTab={this.onChangeTab} />
      </div>
    );
  }
}

export default App;
